import React, { createContext, useState, useEffect } from 'react';

// Create the context
export const BlogContext = createContext();

export const BlogProvider = ({ children }) => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filter, setFilter] = useState({ category: '', searchText: '' });

    // Method to update filter parameters
    const updateFilter = (newFilter) => {
        setFilter(prev => ({ ...prev, ...newFilter }));
    };

    useEffect(() => {
        const fetchAllPosts = async () => {
            try {
                //const response = await fetch(`http://127.0.0.1:3000/blogs`); 
                const response = await fetch(`https://bcakp7miy1.execute-api.eu-central-1.amazonaws.com/blogs`);
                //console.log(`Status: ${response.status}, OK: ${response.ok}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch posts');
                }
                let data = await response.json();
                //data = data.sort((a, b) => new Date(b.CreationDate) - new Date(a.CreationDate));
                const monthMap = {
                    'Januar': 0,
                    'Februar': 1,
                    'Marec': 2,
                    'April': 3,
                    'Maj': 4,
                    'Junij': 5,
                    'Julij': 6,
                    'Avgust': 7,
                    'September': 8,
                    'Oktober': 9,
                    'November': 10,
                    'December': 11
                };

                // Sort by the last number in the PostId
                data = data.sort((a, b) => {
                    const getLastNumber = (postId) => parseInt(postId.split('_').pop());

                    return getLastNumber(b.PostId) - getLastNumber(a.PostId);
                });
                // Preload images
                data.forEach(post => {
                    const img = new Image();
                    img.src = post.ImageSrc;
                });
                setPosts(data);
            } catch (error) {
                console.error("Error fetching posts:", error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAllPosts();
    }, []);

    return (
        <BlogContext.Provider value={{ posts, loading, error, filter, updateFilter }}>
            {children}
        </BlogContext.Provider>
    );
};
